import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { LoaderService } from '../../services/loader-service/loader.service'
import { PageViewBaseComponent } from '../page-view-base/page-view-base.component'

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent extends PageViewBaseComponent {
  constructor(router: Router, loaderService: LoaderService) {
    super(router, loaderService)
  }
}
